import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SrCheckListLdsGet, SrChecklistService } from '@app/services/sr-checklist.service';

@Component({
    selector: 'tt-sr-check-list-lds',
    templateUrl: './sr-check-list-lds.component.html',
    styleUrls: ['./sr-check-list-lds.component.css'],
    standalone: false,
})
export class SrCheckListLdsComponent implements OnInit {
    public page?: SrCheckListLdsGet;
    public lossDamages: Item[] = [];

    constructor(
        private readonly checklist: SrChecklistService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        const params = { checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? '') };
        const [page, lossDamages] = await Promise.all([this.checklist.getLossDamages(params), this.checklist.getLossDamageList(params)]);
        this.page = page;
        this.lossDamages = lossDamages;
    }
}
